export default ({
  fetching: {
    getSearchClient: false
  },
  api: {
    dataSource: []
  }
});